<template>
  <div class="d-flex flex-column" style="align-items: center; height: 100vh; margin-top: 5%;">
    <div>
      <img class="logo" src="/static/images/nav_logo_primary.png" style="width: 169px" />
    </div>
    <div>
      <div class="d-flex flex-column" style="gap: 20px; align-items: center">
        <img src="/static/images/lined_check.svg" style="width: 110px" />
        <div>
          <center style="font-weight: 800; font-size: 30px">
            Check Your Email
          </center>
          <center style="font-weight: 500; font-size: 24px">
            Your account has been created!
          </center>
        </div>
      </div>
    </div>
    <div>
      <v-btn
        round
        dark
        depressed
        class="px-3 mt-4 login-button"
        style="
          width: 300px;
          padding: 15px 5px;
          border-radius: 25px;
          color: white;
          font-size: 18px;
          height: 50px
        "
        @click="sendConfirmEmail"
      >
        Resend email
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      initAppDownload: false,
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      userEmail: (state) => state.app.onboarding.email,
    }),
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    handleNextStage() {
      this.gotoNextStage(this.current + 1);
    },
    handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
    sendConfirmEmail() {
      const params = {
        email: this.userEmail,
      };
      AuthService.sendConfirmEmail(params)
        .then((response) => {
          this.$store.dispatch("error/showSuccessToast", [
            "Resent a confirmation email",
          ]);
        })
        .catch((e) => {
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },
  },
  created() {
    document.getElementById('signup-back-button').remove();
    // this.sendConfirmEmail();
  },
  mounted() {
    $(".bg-natural-grey").removeClass("bg-natural-grey")
  },
};
</script>

<style lang="scss" scoped>
.text-display {
  font-family: Outfit;
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
  text-align: center;
}

.text-display-note {
  font-family: Outfit;
  font-size: 26px;
  font-weight: 600;
  line-height: 42px;
  text-align: center;
}

.text-sf-pro {
  color: #000;
  font-family: DM Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.text-20 {
  font-size: 20px !important;
}

.email {
  color: #4f56ff !important;
  font-size: 18px !important;
}

.auth-button {
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 18.68px;
  text-align: center;
  background: #000000;
  height: 50px;
  border-radius: 56px;
  width: 100%;
}

.pb40 {
  padding-bottom: 40px;
}
.auth {
  max-width: 462px !important;
}

.note {
  font-family: Outfit;
  font-size: 19px;
  font-weight: 600;
  line-height: 23.75px;
  text-align: center;
}

.btn-wrapper {
  box-shadow: 0px 10px 60px 0px #00000033;
  margin-top: 100px;
  border-radius: 30px 30px 0px 0px;
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  padding: 20px;
  z-index: 5;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
}

.onboarding_comp {
  margin-bottom: 230px;
}
</style>



// WEBPACK FOOTER //
// checkEmail.vue?56ed85a5